import { useCallback, useState } from 'react'

import { SERVICE_PACKAGES_TYPES } from '@/libs/constants'

import RequestInfoModal from '.'

export const useRequestInfoModal = () => {
  const [visible, setVisible] = useState(false)
  const [serviceName, setServiceName] = useState(
    SERVICE_PACKAGES_TYPES.INSPECT,
  )

  const render = useCallback(
    ({ companyName, phoneNumber }) =>
      visible && (
        <RequestInfoModal
          onClose={() => setVisible(false)}
          companyName={companyName}
          phoneNumber={phoneNumber}
          serviceName={serviceName}
        />
      ),
    [serviceName, visible],
  )

  return {
    RequestInfoModal: render,
    showRequestInfoModal: (name) => {
      if (!name) {
        // TODO missing service name handler

        return
      }

      setServiceName(name)
      setVisible(true)
    },
  }
}
